import { createSlice } from "@reduxjs/toolkit";
import { forgotPassword, resetPassword } from './thunk'; // Adjust path if necessary

export const initialState = {
  forgetSuccessMsg: null,
  forgetError: null,
  resetSuccessMsg: null,
  resetError: null,
};

// Create the slice
const forgotPasswordSlice = createSlice({
  name: "forgotPassword",
  initialState,
  reducers: {
    // Optional reducers can go here
  },
  extraReducers: (builder) => {
    // Handle forget password actions
    builder
      .addCase(forgotPassword.fulfilled, (state, action) => {
        console.log("Forget password success:", action.payload);
        state.forgetSuccessMsg = action.payload; // Store success message
        state.forgetError = null;
      })
      .addCase(forgotPassword.rejected, (state, action) => {
        console.log("Forget password failed:", action.payload);
        state.forgetError = action.payload; // Store error message
        state.forgetSuccessMsg = null;
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        console.log("Password reset success:", action.payload); // Log success response
        state.resetSuccessMsg = action.payload; // Assuming the message is in the payload
        state.resetError = null;
      })
      .addCase(resetPassword.rejected, (state, action) => {
        console.log("Password reset failed:", action.payload); // Log error response
        state.resetError = action.payload; // Set error from payload
        state.resetSuccessMsg = null;
      });
  },
});

// Export actions and reducer
export default forgotPasswordSlice.reducer;
export { forgotPassword, resetPassword };
